import { render } from "./AquaparkTariffs.vue?vue&type=template&id=1d8fe56b"
import script from "./AquaparkTariffs.vue?vue&type=script&lang=js"
export * from "./AquaparkTariffs.vue?vue&type=script&lang=js"

import "./AquaparkTariffs.vue?vue&type=style&index=0&id=1d8fe56b&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__